import { createUseStyles } from 'react-jss';

var styles = {
  filter: {
    padding: '2rem 1.5rem'
  }
};

var createStyles = createUseStyles(styles);
export { createStyles };
//# sourceMappingURL=styles.js.map